import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import RevokeIcon from '../../../../assets/ci/profile/revoke.svg';
import SimpleListItem from '../../../../components/SimpleListItem';
import { Container, RevokeButton, StyledCard } from '../styled';
import type useWebAuthnSettingsData from './useWebAuthnSettingsData';

type WebAuthnSettingsContentProps = {
    data: ReturnType<typeof useWebAuthnSettingsData>['keysData'];
    revoke: ReturnType<typeof useWebAuthnSettingsData>['revokeKey'];
};

const WebAuthnSettingsContent = ({ data, revoke }: WebAuthnSettingsContentProps) => {
    const { t } = useTranslation('userSelf');
    const currentKeyId = localStorage.getItem('app:webauthnKeyId');

    return (
        <Container>
            {data.map(key => (
                <StyledCard
                    actions={[
                        <RevokeButton
                            disabled={currentKeyId === key.id}
                            icon={<RevokeIcon />}
                            onClick={() => revoke(key.id)}
                        >
                            {t('userSelf:webAuthnSettings.revokeButton')}
                        </RevokeButton>,
                    ]}
                >
                    <Space direction="vertical">
                        {key.items.map(item => (
                            <SimpleListItem {...item} />
                        ))}
                    </Space>
                </StyledCard>
            ))}
        </Container>
    );
};

export default WebAuthnSettingsContent;
